// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2U98p","productName":"Table_productName__1SGTR"};